import {Manage} from "@/Pages/Manage/Manage";
import i18n from "i18next";
import {Card} from "@/Components/Card";
import {usePage} from "@inertiajs/inertia-react";
import Authenticated from "@/Layouts/Authenticated";
import MyModulesCard from "@/Pages/Manage/MyModulesCard";
import "@/../sass/authenticated/subscriptions.scss";
import {useState, useReducer} from "react";
import GeneralPurchaseModal from "@/Pages/BuyFlow/GeneralPurchaseModal";
import { navigateToURL } from '@/Utilities/Util';

function reducer(state, action) {
    switch(action.type) {
        case "showCheckoutModal":
            return { ...state, showCheckoutModal: action.payload.showCheckoutModal }
        default:
            return state;
    }
}

export default function Subscriptions() {

    const props = usePage().props ? usePage().props : null;
    let existingPayingCustomer = usePage().props.auth.current_organization.is_existing_paying_customer;
    const [modulesModal, setModulesModal] = useState(false);
    const features = usePage().props.features;
    const salesloftURL = usePage().props.salesloft_url;
    const isPlatformUnity = usePage().props.auth.current_organization.is_platform_unity;

    const [state, dispatch] = useReducer(reducer, {
        showCheckoutModal: false
    });

    return (
        <div>
            <Manage className="admin-subscriptions" title={i18n.t('subscriptions.subscriptions')}>
                <div className="row">
                    <MyModulesCard state={state}
                                   dispatch={dispatch}
                                   props={props}
                                   existingPayingCustomer={existingPayingCustomer}
                                   setModulesModal={setModulesModal}/>
                </div>
                <div className="row">
                    <Card className="help-ministry-card misc-card col">
                        <div>
                            <div className="misc-card-svg"><img className="help-ministry-svg" src="/images/help-your-ministry.svg"/></div>
                            <div className="misc-card-header">{i18n.t("admin-account-overview.help-ministry-header")}</div>
                            <span className="misc-card-desc">{i18n.t("admin-account-overview.help-ministry-body")}</span>
                            {isPlatformUnity &&
                                <a data-testid={'subscriptions-link-explore'} href="https://help.myamplify.io/hc/en-us"
                                   target="_blank"
                                   className="misc-card-action"
                                >
                                    {i18n.t("admin-account-overview.explore")}
                                </a>
                            }
                            {!isPlatformUnity &&
                                <a data-testid={'subscriptions-link-explore'}
                                   href="https://support.parishsoft.com/hc/en-us"
                                   target="_blank"
                                   className="misc-card-action"
                                >
                                    {i18n.t("admin-account-overview.explore")}
                                </a>
                            }
                        </div>
                    </Card>
                    {features['checkout'] &&  <Card className="upgrade-bundle-card misc-card col">
                        <div>
                            <div className="misc-card-svg"><img src="/images/upgrade-your-bundle.svg"/></div>
                            <div
                                className="misc-card-header">{i18n.t("admin-account-overview.upgrade-bundle-header")}</div>
                            <span
                                className="misc-card-desc">{i18n.t("admin-account-overview.upgrade-bundle-body")}</span>
                            <span data-testid={'subscriptions-link-upgrade'} href="/manage/buyflow"
                                  onClick={() => !salesloftURL ? dispatch({
                                      type: "showCheckoutModal",
                                      payload: {showCheckoutModal: true}
                                  }) : navigateToURL(salesloftURL)}
                                  className="misc-card-action">{i18n.t("admin-account-overview.upgrade")}</span>
                        </div>
                    </Card>}
                </div>
            </Manage>
            {state.showCheckoutModal ? <GeneralPurchaseModal state={state} dispatch={dispatch}/> : null}
        </div>
    )
}

Subscriptions.layout = page => <Authenticated children={page}></Authenticated>
